var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C10.5857 12 9.42857 13.1571 9.42857 14.5714C9.42857 15.9857 10.5857 17.1429 12 17.1429C13.4143 17.1429 14.5714 15.9857 14.5714 14.5714C14.5714 13.1571 13.4143 12 12 12ZM20.4013 6.90134L17.0304 3.53036C16.7049 3.2033 16.2107 3 15.7004 3H5.57143C4.15112 3 3 4.15112 3 5.57143V18.4286C3 19.8489 4.15112 21 5.57143 21H18.4286C19.8489 21 21 19.8489 21 18.4286V8.29955C21 7.78929 20.7951 7.29509 20.4013 6.90134ZM8.14286 4.92857H13.9286V8.14286H8.14286V4.92857ZM19.0714 18.4286C19.0714 18.7836 18.7836 19.0714 18.4286 19.0714H5.57143C5.21641 19.0714 4.92857 18.7836 4.92857 18.4286V5.57143C4.92857 5.21633 5.21641 4.92857 5.57143 4.92857H6.21429V9.10714C6.21429 9.63951 6.64621 10.0714 7.17857 10.0714H14.8929C15.4272 10.0714 15.8571 9.64152 15.8571 9.10714V5.08446L19.0011 8.22844C19.0473 8.27143 19.0714 8.33571 19.0714 8.39598V18.4286Z",
    fill: "#002C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.a03f70858b4f8b7c12c8ac9c16160f4f.svg";
export { ForwardRef as ReactComponent };